import { MutationHookOptions } from "@apollo/client"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"
import { useMutationWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"

/**
 * Custom hook that provides all activity-related mutations
 */
export function useActivityMutations(mutationOptions: MutationHookOptions = {}) {
  const [createActivity] = useMutationWithEndpoint(gqlTypes.CreateActivityDocument, mutationOptions as any, "primary")
  const [updateActivity] = useMutationWithEndpoint(gqlTypes.UpdateActivityDocument, mutationOptions as any, "primary")
  const [createActivityEvent] = useMutationWithEndpoint(gqlTypes.CreateActivityEventDocument, mutationOptions as any, "primary")
  const [createActivityAttribute] = useMutationWithEndpoint(
    gqlTypes.CreateActivityAttributeDocument,
    mutationOptions as any,
    "primary"
  )
  const [updateActivityAttribute] = useMutationWithEndpoint(
    gqlTypes.UpdateActivityAttributeDocument,
    mutationOptions as any,
    "primary"
  )
  const [updateActivityAttributes] = useMutationWithEndpoint(
    gqlTypes.UpdateActivityAttributesDocument,
    mutationOptions as any,
    "primary"
  )
  const [deleteActivityAttribute] = useMutationWithEndpoint(
    gqlTypes.DeleteActivityAttributeDocument,
    mutationOptions as any,
    "primary"
  )
  const [deleteActivity] = useMutationWithEndpoint(gqlTypes.DeleteActivityDocument, mutationOptions as any, "primary")
  const [updateActivityAssets] = useMutationWithEndpoint(
    gqlTypes.UpdateActivityAssetsDocument,
    mutationOptions as any,
    "primary"
  )

  return {
    createActivity,
    updateActivity,
    createActivityEvent,
    createActivityAttribute,
    updateActivityAttribute,
    updateActivityAttributes,
    deleteActivityAttribute,
    deleteActivity,
    updateActivityAssets,
  }
}
